import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateTime' })
export class DateTimePipe implements PipeTransform {

    transform(value: Date) {
        if (value) {
            var dateString = value.toString();
            return moment(dateString).format('MM/DD/YYYY h:mm:ss a');
        }
        return undefined;
    }
}
